import Axios from "axios";

import type { ISettingsApi, ISettingsServ } from "../modules/Settings";

export default class SettingsApi implements ISettingsApi {
    getSettings(): Promise<ISettingsServ> {
        return Axios.get<ISettingsServ>("/api/Settings").then(resp => resp.data);
    }
}
